import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';

@Component({
  selector: 'app-input-switch-molecule',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputSwitchModule],
  templateUrl: './input-switch-molecule.component.html',
  styleUrl: './input-switch-molecule.component.scss',
})
export class InputSwitchMoleculeComponent {
  @Input() form!: FormGroup;
  @Input() name!: string;
  @Input() id!: string;
  @Input() label?: string;
  @Input() class?: string;
  @Input() classLabel?: string;
}
